import React from 'react'
import { Typography, Form } from 'antd'
import { tipologie, gender } from '../assets/constants'
import _ from 'lodash'
import ExtraRadioGroup from './extraRadioGroup'

const { Title } = Typography

const Sesso = (props) => {
  const tipologia = _.get(props.formValue, 'tipologia')
  return (
    <>
      <Title>
        Vuoi affitrare
        {tipologia === '2' ? ' la ' : ' il '}
        {_.get(tipologie, `[${parseInt(tipologia)}]`)} a
      </Title>
      <Form.Item name='sesso' rules={[{ required: true }]}>
        <ExtraRadioGroup
          values={gender}
          defaultValue={_.get(props.formValue, 'sesso')}
          setOnForm={(value) => {
            props.addValue({ sesso: value })
            props.form.setFieldsValue({ sesso: value })
          }}
          name='sesso'
        />
      </Form.Item>
    </>
  )
}

export default Sesso
